import "./styles.css";

const app = document.querySelector<HTMLElement>("#app");

if (!app) {
  throw new Error("Missing #app root.");
}

app.innerHTML = `
  <section class="page-shell" aria-labelledby="page-title">
    <div class="mark-wrap" aria-hidden="true">
      <img class="mark" src="/playfulthinking-mark.svg" alt="" />
    </div>
    <div class="copy">
      <p class="eyebrow">Product studio</p>
      <h1 id="page-title">Playful Thinking</h1>
      <p class="lede">
        We make small, strange, useful software. We are mostly in stealth mode right now.
      </p>
      <p class="note">See you soon.</p>
    </div>
  </section>
`;
